
import React, { createContext, useContext, useState } from 'react';



const CartContext = createContext();


export const CartProvider = ({ children }) => {
  const [totalPrice, setTotalPrice] = useState(
    sessionStorage.getItem('cartTotalValue') == null
      ? 0
      : parseFloat(sessionStorage.getItem('cartTotalValue'))
  );

  const [itemQuantities, setItemQuantities] = useState(
    sessionStorage.getItem('cartQuantityValue') == null
      ? {}
      : JSON.parse(sessionStorage.getItem('cartQuantityValue'))
  );


  const resetItemQuantities = () => {
    setItemQuantities({});
    sessionStorage.setItem("cartQuantityValue", JSON.stringify({}));
  };


  const updateTotalPrice = (priceChange) => {
    const numericChange = parseFloat(priceChange);
    //  console.log(numericChange);
    if (!isNaN(numericChange)) {
      setTotalPrice((prevTotal) => prevTotal + numericChange);
    } else {
      console.error('Invalid numeric value:', priceChange);
    }
  };

  const resetTotalPrice = () => {
    setTotalPrice(0);
    sessionStorage.setItem("cartTotalValue", "0");
  };

  const updateQuantity = (_id, newQuantity, price, offerPrice) => {
    // console.log(newQuantity);

    const finalPrice = offerPrice || price;

    setItemQuantities((prevQuantities) => ({
      ...prevQuantities,
      [_id]: { quantity: newQuantity, price: finalPrice }
    }));

    let total = 0;
    const cartItems = { ...itemQuantities, [_id]: { quantity: newQuantity, price: finalPrice } };

    Object.keys(cartItems).forEach((element) => {
      total += cartItems[element]?.quantity * parseFloat(cartItems[element]?.price);
    });

    setTotalPrice(total.toFixed(2));
    sessionStorage.setItem("cartQuantityValue", JSON.stringify(cartItems));
    sessionStorage.setItem("cartTotalValue", total.toFixed(2));
  };
  const removeItem = (_id) => {
    setItemQuantities((prev) => {
      const updated = { ...prev };
      delete updated[_id];

      let total = 0;
      Object.values(updated).forEach((i) => {
        total += i.quantity * parseFloat(i.price);
      });

      setTotalPrice(total.toFixed(2));
      sessionStorage.setItem("cartQuantityValue", JSON.stringify(updated));
      sessionStorage.setItem("cartTotalValue", total.toFixed(2));

      return updated;
    });
  };



  return (
    <CartContext.Provider
      value={{ totalPrice, setTotalPrice, updateTotalPrice, resetTotalPrice, itemQuantities, setItemQuantities, updateQuantity, resetItemQuantities, removeItem }}>
      {children}
    </CartContext.Provider>

  );
};


export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
